import { render, staticRenderFns } from "./DetailDokumentasiList.vue?vue&type=template&id=1ca4ae48&scoped=true"
import script from "./DetailDokumentasiList.vue?vue&type=script&lang=js"
export * from "./DetailDokumentasiList.vue?vue&type=script&lang=js"
import style0 from "./DetailDokumentasiList.vue?vue&type=style&index=0&id=1ca4ae48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca4ae48",
  null
  
)

export default component.exports